import { actionConstants } from '../constants';
import {
  failReqActionType,
  startReqActionType,
  successReqActionType
} from 'helper/requestHelper';

const initialState = {
  clusterMetrics: null,
  isLoadingClusterMetrics: false,

  deploymentsMetrics: [],
  isLoadingDeploymentsMetrics: false,

  deploymentMetrics: null,
  isLoadingDeploymentMetrics: false,

  podsMetrics: [],
  isLoadingPodsMetrics: false,

  workloads: [],
  isLoadingWorkloads: false,

  workloadPods: [],
  isLoadingWorkloadPods: false,

  podLogs: null,
  isLoadingPodLogs: false,

  workloadLogs: {},
  isLoadingWorkloadLogs: false,

  error: null
};

const gkeReducer = (state = initialState, action) => {
  switch (action.type) {
    case startReqActionType(actionConstants.GET_GKE_CLUSTER_METRICS):
      return {
        ...state,
        isLoadingClusterMetrics: true
      };
    case successReqActionType(actionConstants.GET_GKE_CLUSTER_METRICS):
      return {
        ...state,
        isLoadingClusterMetrics: false,
        clusterMetrics: action.payload
      };
    case failReqActionType(actionConstants.GET_GKE_CLUSTER_METRICS):
      return {
        ...state,
        isLoadingClusterMetrics: false,
        clusterMetrics: null
      };

    case startReqActionType(actionConstants.GET_GKE_DEPLOYMENTS_METRICS):
      return {
        ...state,
        isLoadingDeploymentsMetrics: true
      };
    case successReqActionType(actionConstants.GET_GKE_DEPLOYMENTS_METRICS):
      return {
        ...state,
        isLoadingDeploymentsMetrics: false,
        deploymentsMetrics: action.payload
      };
    case failReqActionType(actionConstants.GET_GKE_DEPLOYMENTS_METRICS):
      return {
        ...state,
        isLoadingDeploymentsMetrics: false,
        deploymentsMetrics: []
      };

    case startReqActionType(actionConstants.GET_GKE_DEPLOYMENT_METRICS):
      return {
        ...state,
        isLoadingDeploymentMetrics: true
      };
    case successReqActionType(actionConstants.GET_GKE_DEPLOYMENT_METRICS):
      return {
        ...state,
        isLoadingDeploymentMetrics: false,
        deploymentMetrics: action.payload
      };
    case failReqActionType(actionConstants.GET_GKE_DEPLOYMENT_METRICS):
      return {
        ...state,
        isLoadingDeploymentMetrics: false,
        deploymentMetrics: null
      };

    case startReqActionType(actionConstants.GET_GKE_PODS_METRICS):
      return {
        ...state,
        isLoadingPodsMetrics: true
      };
    case successReqActionType(actionConstants.GET_GKE_PODS_METRICS):
      return {
        ...state,
        isLoadingPodsMetrics: false,
        podsMetrics: action.payload
      };
    case failReqActionType(actionConstants.GET_GKE_PODS_METRICS):
      return {
        ...state,
        isLoadingPodsMetrics: false,
        podsMetrics: []
      };

    case startReqActionType(actionConstants.GET_GKE_WORKLOADS):
      return {
        ...state,
        isLoadingWorkloads: true
      };
    case successReqActionType(actionConstants.GET_GKE_WORKLOADS):
      return {
        ...state,
        isLoadingWorkloads: false,
        workloads: action.payload
      };
    case failReqActionType(actionConstants.GET_GKE_WORKLOADS):
      return {
        ...state,
        isLoadingWorkloads: false,
        workloads: []
      };

    case startReqActionType(actionConstants.GET_GKE_WORKLOAD_PODS):
      return {
        ...state,
        isLoadingWorkloadPods: true
      };
    case successReqActionType(actionConstants.GET_GKE_WORKLOAD_PODS):
      return {
        ...state,
        isLoadingWorkloadPods: false,
        workloadPods: action.payload
      };
    case failReqActionType(actionConstants.GET_GKE_WORKLOAD_PODS):
      return {
        ...state,
        isLoadingWorkloadPods: false,
        workloadPods: []
      };

    case startReqActionType(actionConstants.GET_GKE_POD_LOGS):
      return {
        ...state,
        isLoadingPodLogs: true
      };
    case successReqActionType(actionConstants.GET_GKE_POD_LOGS):
      return {
        ...state,
        isLoadingPodLogs: false,
        podLogs: action.payload
      };
    case failReqActionType(actionConstants.GET_GKE_POD_LOGS):
      return {
        ...state,
        isLoadingPodLogs: false,
        podLogs: null
      };

    case startReqActionType(actionConstants.GET_GKE_WORKLOAD_LOGS):
      return {
        ...state,
        isLoadingWorkloadLogs: true
      };
    case successReqActionType(actionConstants.GET_GKE_WORKLOAD_LOGS):
      return {
        ...state,
        isLoadingWorkloadLogs: false,
        workloadLogs: action.payload
      };
    case failReqActionType(actionConstants.GET_GKE_WORKLOAD_LOGS):
      return {
        ...state,
        isLoadingWorkloadLogs: false,
        workloadLogs: {}
      };

    default:
      return state;
  }
};

export default gkeReducer;
